export default __webpack_public_path__ + "static/media/Ellipse 3.ec758d1c.svg";